export default __webpack_public_path__ + "static/Element-4ed3ed37136e61e65df36dbb87308e43.png";